<template>
    <div
        class="col-md-12 col-lg-12 pr_50 mobile_pr_15 rv_pay pay-mode review_and_pay_page"
    >
        <div
            class="cart_summary h-100 white_box py_52 px_52 cart-shipping-address"
        >
            <h4 class="font_size_30 d-flex mb_28 cart_summary_heading_h4">
                4. Review & pay
                <router-link
                    v-show="cartNotEmpty"
                    :to="{ path: '/cart/v3' }"
                    class="ml-auto"
                    title="Edit Cart"
                    ><img src="/maincss/images/edit.svg" alt=" "
                /></router-link>
            </h4>
            <div class="review_and_pay_page_content">
                <div>
                    <h3
                        v-if="order_data.sameaddress"
                        class="font_size_30 d-flex mb_28 cart_summary_heading_h4"
                    >
                        Billing & Shipping Addresss
                        <a
                            v-on:click="editData('shipping_billing')"
                            class="ml-2"
                            ><img
                                src="/maincss/images/edit.svg"
                                alt=" "
                                data-toggle="tooltip"
                                data-placement="bottom"
                                v-tooltip="'Edit'"
                        /></a>
                    </h3>

                    <div class="company_card_rp">
                        <div class="company_card_name">
                            {{ $parent.order_data.address_label }}
                        </div>
                        <div
                            class="company_card_address user_name_address"
                            v-if="
                                $parent.order_data.billing_first_name &&
                                $parent.order_data.billing_last_name
                            "
                        >
                            {{ $parent.order_data.billing_first_name }}
                            {{ $parent.order_data.billing_last_name }}
                        </div>
                        <div v-else-if="$parent.order_data.fullname">
                            {{ $parent.order_data.fullname }}
                        </div>
                        <div class="company_card_address">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.9375 5.6875C10.9375 4.64321 10.5227 3.64169 9.78423 2.90327C9.04581 2.16484 8.04429 1.75 7 1.75C5.95571 1.75 4.95419 2.16484 4.21577 2.90327C3.47734 3.64169 3.0625 4.64321 3.0625 5.6875C3.0625 7.30275 4.35488 9.408 7 11.9297C9.64512 9.408 10.9375 7.30275 10.9375 5.6875ZM7 13.125C3.79137 10.2086 2.1875 7.72888 2.1875 5.6875C2.1875 4.41115 2.69453 3.18707 3.59705 2.28455C4.49957 1.38203 5.72365 0.875 7 0.875C8.27635 0.875 9.50043 1.38203 10.403 2.28455C11.3055 3.18707 11.8125 4.41115 11.8125 5.6875C11.8125 7.72888 10.2086 10.2086 7 13.125Z"
                                    fill="#414141"
                                    stroke="#414141"
                                    stroke-width="0.416667"
                                />
                                <path
                                    d="M7 7C7.3481 7 7.68194 6.86172 7.92808 6.61558C8.17422 6.36944 8.3125 6.0356 8.3125 5.6875C8.3125 5.3394 8.17422 5.00556 7.92808 4.75942C7.68194 4.51328 7.3481 4.375 7 4.375C6.6519 4.375 6.31806 4.51328 6.07192 4.75942C5.82578 5.00556 5.6875 5.3394 5.6875 5.6875C5.6875 6.0356 5.82578 6.36944 6.07192 6.61558C6.31806 6.86172 6.6519 7 7 7ZM7 7.875C6.41984 7.875 5.86344 7.64453 5.4532 7.2343C5.04297 6.82406 4.8125 6.26766 4.8125 5.6875C4.8125 5.10734 5.04297 4.55094 5.4532 4.1407C5.86344 3.73047 6.41984 3.5 7 3.5C7.58016 3.5 8.13656 3.73047 8.5468 4.1407C8.95703 4.55094 9.1875 5.10734 9.1875 5.6875C9.1875 6.26766 8.95703 6.82406 8.5468 7.2343C8.13656 7.64453 7.58016 7.875 7 7.875Z"
                                    fill="#414141"
                                    stroke="#414141"
                                    stroke-width="0.416667"
                                />
                            </svg>
                            <span
                                >{{ $parent.order_data.address1 }}
                                {{ $parent.order_data.address2 }},
                                {{ $parent.order_data.city }},
                                {{ $parent.order_data.addressstate }}
                                {{ $parent.order_data.addresszip }}</span
                            >
                        </div>
                        <div class="company_card_contact">
                            <div class="company_card_phone">
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12.821 10.6938C12.821 10.9038 12.7744 11.1196 12.6752 11.3296C12.576 11.5396 12.4477 11.738 12.2785 11.9246C11.9927 12.2396 11.6777 12.4671 11.3219 12.613C10.9719 12.7588 10.5927 12.8346 10.1844 12.8346C9.58938 12.8346 8.95354 12.6946 8.28271 12.4088C7.61187 12.123 6.94104 11.738 6.27604 11.2538C5.60521 10.7638 4.96937 10.2213 4.36271 9.62047C3.76187 9.0138 3.21937 8.37797 2.73521 7.71297C2.25687 7.04797 1.87187 6.38297 1.59188 5.7238C1.31188 5.0588 1.17188 4.42297 1.17188 3.8163C1.17188 3.41964 1.24187 3.04047 1.38187 2.69047C1.52187 2.33464 1.74354 2.00797 2.05271 1.7163C2.42604 1.3488 2.83438 1.16797 3.26604 1.16797C3.42938 1.16797 3.59271 1.20297 3.73854 1.27297C3.89021 1.34297 4.02437 1.44797 4.12937 1.59964L5.48271 3.50714C5.58771 3.65297 5.66354 3.78714 5.71604 3.91547C5.76854 4.03797 5.79771 4.16047 5.79771 4.2713C5.79771 4.4113 5.75687 4.5513 5.67521 4.68547C5.59938 4.81964 5.48854 4.95964 5.34854 5.09964L4.90521 5.56047C4.84104 5.62464 4.81187 5.70047 4.81187 5.7938C4.81187 5.84047 4.81771 5.8813 4.82938 5.92797C4.84688 5.97464 4.86438 6.00964 4.87604 6.04464C4.98104 6.23714 5.16187 6.48797 5.41854 6.7913C5.68104 7.09464 5.96104 7.4038 6.26437 7.71297C6.57937 8.02214 6.88271 8.30797 7.19187 8.57047C7.49521 8.82714 7.74604 9.00214 7.94437 9.10714C7.97354 9.1188 8.00854 9.1363 8.04937 9.1538C8.09604 9.1713 8.14271 9.17714 8.19521 9.17714C8.29437 9.17714 8.37021 9.14214 8.43437 9.07797L8.87771 8.64047C9.02354 8.49464 9.16354 8.3838 9.29771 8.3138C9.43187 8.23214 9.56604 8.1913 9.71187 8.1913C9.82271 8.1913 9.93937 8.21464 10.0677 8.26714C10.196 8.31964 10.3302 8.39547 10.476 8.49464L12.4069 9.86547C12.5585 9.97047 12.6635 10.093 12.7277 10.2388C12.786 10.3846 12.821 10.5305 12.821 10.6938Z"
                                        stroke="#414141"
                                        stroke-width="1.2"
                                        stroke-miterlimit="10"
                                    />
                                </svg>
                                <span>{{ $parent.order_data.phone }}</span>
                            </div>
                            <div class="company_card_email">
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12.8385 4.07812L7.59379 7.41888C7.41581 7.52225 7.21366 7.5767 7.00783 7.5767C6.80201 7.5767 6.59985 7.52225 6.42188 7.41888L1.17188 4.07812"
                                        stroke="#414141"
                                        stroke-width="1.3"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M11.6719 2.32812H2.33854C1.69421 2.32812 1.17188 2.85046 1.17188 3.49479V10.4948C1.17188 11.1391 1.69421 11.6615 2.33854 11.6615H11.6719C12.3162 11.6615 12.8385 11.1391 12.8385 10.4948V3.49479C12.8385 2.85046 12.3162 2.32812 11.6719 2.32812Z"
                                        stroke="#414141"
                                        stroke-width="1.3"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                <span> {{ $parent.order_data.email }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="mt_22">
                    <p class="mb-0 text_light_grey" v-if="
                        $parent.order_data.billing_first_name &&
                        $parent.order_data.billing_last_name
                    ">
                        <b>Recipient Name:</b>
                        {{
                        $parent.order_data.billing_first_name +
                        " " +
                        $parent.order_data.billing_last_name
                        }}
                    </p>


                    <p class="mb-0 text_light_grey" v-if="$parent.order_data.address_label">
                        <b>Company Name:</b> {{ $parent.order_data.address_label }}
                    </p>
                    <p class="mb-0 text_light_grey" v-else>
                        <b>Recipient Name:</b> {{ $parent.order_data.fullname }}
                    </p>
                    <p class="mb-0 text_light_grey" v-if="$parent.order_data.address1">
                        {{ $parent.order_data.address1 }}
                    </p>
                    <p class="mb-0 text_light_grey" v-if="$parent.order_data.address2">
                        {{ $parent.order_data.address2 }}
                    </p>
                    <p class="mb-0 text_light_grey" v-if="
                        $parent.order_data.city ||
                        $parent.order_data.addressstate ||
                        $parent.order_data.addresszip
                    ">
                        {{
                        [
                        $parent.order_data.city,
                        $parent.order_data.addressstate
                        ? $parent.order_data.addressstate +
                        ($parent.order_data.addresszip
                        ? " " + $parent.order_data.addresszip
                        : "")
                        : ""
                        ]
                        .filter(Boolean)
                        .join(", ")
                        }}
                    </p>
                    <p class="mb-0 text_light_grey">
                        <img src="/images/mail.svg" alt="icon" />
                        {{ $parent.order_data.email }}
                    </p>
                    <p class="mb-0 text_light_grey">
                        <img src="/images/call.svg" alt="icon" />
                        {{ $parent.order_data.phone }}
                    </p>
                </div> -->
                <!-- <br v-if="!$parent.order_data.sameaddress" /> -->
                <!-- <div v-if="!$parent.order_data.sameaddress">
                    <h4 class="font_size_30 d-flex mb_24">
                        Shipping Address
                        <a v-on:click="editData('shipping_billing')" class="ml-auto"><img src="/maincss/images/edit.svg"
                                alt=" " data-toggle="tooltip" data-placement="bottom" v-tooltip="'Edit'" /></a>
                    </h4>

                    <div class="presnol_info mt_22">
                        <p class="mb-0 text_light_grey" v-if="
                            $parent.order_data.shipping_first_name &&
                            $parent.order_data.shipping_last_name
                        ">
                            <b>Recipient Name:</b>
                            {{
                            $parent.order_data.shipping_first_name +
                            " " +
                            $parent.order_data.shipping_last_name
                            }}
                        </p>

                        <p v-if="$parent.order_data.shippingaddress_label" class="mb-0 text_light_grey">
                            <b>Company Name:</b>
                            {{ $parent.order_data.shippingaddress_label }}
                        </p>
                        <p class="mb-0 text_light_grey" v-else>
                            <b>Recipient Name:</b>
                            {{ $parent.order_data.fullname }}
                        </p>
                        <p v-if="$parent.order_data.shippingaddress1" class="mb-0 text_light_grey">
                            {{ $parent.order_data.shippingaddress1 }}
                        </p>
                        <p v-if="$parent.order_data.shippingaddress2" class="mb-0 text_light_grey">
                            {{ $parent.order_data.shippingaddress2 }}
                        </p>
                        <p class="mb-0 text_light_grey" v-if="
                            $parent.order_data.shippingcity ||
                            $parent.order_data.shippingaddressstate ||
                            $parent.order_data.shippingaddresszip
                        ">
                            {{
                            [
                            $parent.order_data.shippingcity,
                            $parent.order_data.shippingaddressstate
                            ? $parent.order_data.shippingaddressstate +
                            ($parent.order_data.shippingaddresszip
                            ? " " +
                            $parent.order_data
                            .shippingaddresszip
                            : "")
                            : ""
                            ]
                            .filter(Boolean)
                            .join(", ")
                            }}
                        </p>
                        <p class="mb-0 text_light_grey">
                            <img src="/images/mail.svg" alt="icon" />
                            {{ $parent.order_data.email }}
                        </p>
                        <p class="mb-0 text_light_grey">
                            <img src="/images/call.svg" alt="icon" />
                            {{ $parent.order_data.phone }}
                        </p>
                    </div>
                </div> -->

                <div class="mt_32">
                    <h3 class="r_and_p_heading mb_16">
                        Payment Method
                        <a
                            v-on:click="editData('payment_shipment')"
                            class="rp_edit_btn"
                            ><img
                                src="/maincss/images/edit.svg"
                                alt=" "
                                data-toggle="tooltip"
                                data-placement="bottom"
                                v-tooltip="'Edit'"
                        /></a>
                    </h3>
                    <p
                        v-if="
                            $parent.order_data.is_cod &&
                            !(
                                $parent.order_data.customerPaymentProfileId ||
                                $parent.order_data.cardnumber
                            )
                        "
                    >
                        <span> COD </span>
                    </p>
                    <p
                        class="rp_prefield_state"
                        v-if="
                            $parent.order_data.is_pay_later &&
                            !(
                                $parent.order_data.customerPaymentProfileId ||
                                $parent.order_data.cardnumber
                            ) &&
                            !$parent.order_data.is_pay_way_terms
                        "
                    >
                        <span> Send Payment Link </span>
                    </p>
                    <!-- Pay Via Terms only (no remaining card payment) -->
                    <p
                        class="rp_prefield_state"
                        v-if="
                            $parent.order_data.is_pay_way_terms &&
                            !showRemainingCardPayment &&
                            !(
                                $parent.order_data.customerPaymentProfileId ||
                                $parent.order_data.cardnumber
                            )
                        "
                    >
                        <span>
                            Pay Via Terms ({{
                                icPriceFormat(
                                    orderTotalAmount || 0
                                )
                            }})
                        </span>
                    </p>

                    <!-- Pay Via Terms + Remaining Card Payment (both together on same line) -->
                    <p
                        class="rp_prefield_state"
                        v-if="showRemainingCardPayment"
                    >
                        <span>
                            Pay Via Terms ({{
                                icPriceFormat(
                                    termPaymentInfo.avalaible_on_account || 0
                                )
                            }}) + 
                            <template v-if="$parent.order_data.remaining_pay_card_details && ($parent.order_data.remaining_pay_card_details.cardnumber || $parent.order_data.remaining_pay_card_details.customerPaymentProfileId)">
                                <img
                                    :src="getCardImage($parent.order_data.remaining_pay_card_details.cardtype || 'Visa')"
                                    alt="card"
                                    class="mr_8 ml_8"
                                    style="vertical-align: middle; height: 20px;"
                                />
                                Card ending with {{
                                    $parent.order_data.remaining_pay_card_details.cardnumber
                                        ? $parent.order_data.remaining_pay_card_details.cardnumber.substr(
                                              -4
                                          )
                                        : ""
                                }}
                            </template>
                            <template v-else>
                                <span class="ml_8">Card</span>
                            </template>
                            ({{ icPriceFormat(remainingCardAmount) }})
                        </span>
                    </p>

                    <!-- Show saved card or selected card payment method -->
                    <div
                        v-if="
                            ($parent.order_data.is_saved_card ||
                                ($parent.order_data.customerPaymentProfileId &&
                                    !$parent.order_data.is_cod &&
                                    !$parent.order_data.is_pay_later &&
                                    !$parent.order_data.is_pay_way_terms)) &&
                            $parent.order_data.cardnumber
                        "
                        class="presnol_info mt_22"
                    >
                        <p class="mb-0 text_light_grey">
                            <img
                                :src="getCardImage($parent.order_data.cardtype)"
                                alt="card"
                                class="mr_14"
                            />ending with
                            {{
                                $parent.order_data.cardnumber
                                    ? $parent.order_data.cardnumber.substr(-4)
                                    : ""
                            }}
                        </p>
                    </div>
                </div>
                <div class="mt_32">
                    <h3 class="r_and_p_heading mb_16">
                        Shipping carrier
                        <a
                            v-on:click="editData('payment_shipment')"
                            class="rp_edit_btn"
                            ><img
                                src="/maincss/images/edit.svg"
                                alt=" "
                                data-toggle="tooltip"
                                data-placement="bottom"
                                v-tooltip="'Edit'"
                        /></a>
                    </h3>
                    <!-- <p class="rp_prefield_state">
                  <img src="/maincss/images/fedex.png" alt="carrier" class="carrier_img" >
                </p> -->
                    <div class="rp_prefield_state">
                        <p class="mb-0 text_light_grey">
                            <img
                                :src="order_data.shippingproviderimage"
                                alt="Not Available "
                            />
                        </p>
                    </div>
                </div>
                <div class="mt_32">
                    <h3 class="r_and_p_heading mb_16">
                        Shipping Methods
                        <a
                            v-on:click="editData('payment_shipment')"
                            class="rp_edit_btn"
                            ><img
                                src="/maincss/images/edit.svg"
                                alt=" "
                                data-toggle="tooltip"
                                data-placement="bottom"
                                v-tooltip="'Edit'"
                        /></a>
                    </h3>
                    <!-- <p class="rp_prefield_state">FedEx Ground®</p> -->
                    <div class="rp_prefield_state">
                        <p class="mb-0 text_light_grey">
                            {{
                                $parent.selected_shiping_method
                                    ? $parent.selected_shiping_method
                                          .serviceName
                                    : ""
                            }}
                        </p>
                    </div>
                </div>

                <!-- <h4 class="font_size_30 d-flex mb_20 mt_30">
                    Payment Method

                    <a v-on:click="editData('payment_shipment')" class="ml-auto"><img src="/maincss/images/edit.svg"
                            alt=" " data-toggle="tooltip" data-placement="bottom" v-tooltip="'Edit'" /></a>
                </h4>

                <p v-if="order_data.is_cod">
                    <span> COD </span>
                </p>
                <p v-if="order_data.is_pay_later">
                    <span> Send Payment Link </span>
                </p>
                <p v-if="
                    order_data.is_pay_way_terms &&
                    termPaymentInfo.avalaible_on_account > 0
                ">
                    <span v-if="
                        termPaymentInfo.avalaible_on_account <
                        order_data.order_price
                    ">
                        Pay Via Terms({{
                        icPriceFormat(termPaymentInfo.avalaible_on_account)
                        }})
                    </span>
                    <span v-else-if="
                        termPaymentInfo.avalaible_on_account >=
                        order_data.order_price
                    ">
                        Pay Via Terms({{ icPriceFormat(order_data.order_price) }})
                    </span>
                    <span v-else>
                        Pay Via Terms({{ icPriceFormat(order_data.order_price) }})
                    </span>
                </p> -->
                <!-- <div v-if="termPaymentInfo.balance_remaining_card_amount" class="presnol_info mt_22">
                    <p class="mb-0 text_light_grey">
                        <img src="/maincss/images/visa_logo.png" alt=" " class="mr_14" />
                        ending with
                        {{
                        order_data.remaining_pay_card_details.cardnumber
                        ? order_data.remaining_pay_card_details.cardnumber.substr(
                        -4
                        )
                        : ""
                        }}
                    </p>
                    <p>
                        ({{
                        icPriceFormat(
                        termPaymentInfo.balance_remaining_card_amount || 0
                        )
                        }})
                    </p>
                </div>

                <div v-if="$parent.order_data.is_saved_card" class="presnol_info mt_22">
                    <p class="mb-0 text_light_grey">
                        <img src="/maincss/images/visa_logo.png" alt=" " class="mr_14" />ending with
                        {{
                        $parent.order_data.cardnumber
                        ? $parent.order_data.cardnumber.substr(-4)
                        : ""
                        }}
                    </p>
                </div> -->

                <!-- <h4 class="font_size_30 d-flex mb_24 mt_30 shipping_heading">
                    Shipping Carrier
                    <a v-on:click="editData('shipping_billing')" class="ml-auto"><img src="/maincss/images/edit.svg"
                            alt=" " data-toggle="tooltip" data-placement="bottom" v-tooltip="'Edit'" /></a>
                </h4>

                <div class="presnol_info shipping_carrier_info">
                    <p class="mb-0 text_light_grey">
                        <img :src="order_data.shippingproviderimage" alt="Not Available " />
                    </p>
                </div> -->

                <!-- <h4 class="font_size_30 d-flex mb_24 shipping_heading shipping_method_info_heading">
                    Shipping Methods
                    <a v-on:click="editData('shipping_billing')" class="ml-auto"><img src="/maincss/images/edit.svg"
                            alt=" " data-toggle="tooltip" data-placement="bottom" v-tooltip="'Edit'" /></a>
                </h4>

                <div class="presnol_info shipping_carrier_info">
                    <p class="mb-0 text_light_grey">
                        {{
                        $parent.selected_shiping_method
                        ? $parent.selected_shiping_method.serviceName
                        : ""
                        }}
                    </p>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["order_data", "termPaymentInfo"],
    data() {
        return {
            cartNotEmpty:
                localStorage.getItem("cartNotEmpty") === "true" || false,
            showRemainingCardPayment: false
            // order_data: {
            //   giftcardnumber: "",
            //   giftcardpin: "",
            //   specialcomment: "",
            //   couponcode: ""
            // }
        };
    },
    computed: {
        orderTotalAmount() {
            return parseFloat(
                this.$parent.order_data.order_price || 
                this.$parent.order_data.grand_total_price || 
                this.$parent.order_data.grand_total || 
                this.order_data.order_price || 
                this.order_data.grand_total_price || 
                this.order_data.grand_total || 
                (this.$parent.$refs.cartSummaryRef ? this.$parent.$refs.cartSummaryRef.calculatedGrandTotal : 0) ||
                0
            );
        },
        remainingCardAmount() {
            const orderTotal = parseFloat(
                this.order_data.order_price || 
                this.order_data.grand_total_price || 
                this.order_data.grand_total || 
                (this.$parent.$refs.cartSummaryRef ? this.$parent.$refs.cartSummaryRef.calculatedGrandTotal : 0) ||
                0
            );
            const availableAccount = parseFloat(this.termPaymentInfo && this.termPaymentInfo.avalaible_on_account || 0);
            
            // If available account is negative or zero, show full order total
            // If available account is positive but less than order total, show remaining amount
            if (availableAccount > 0 && orderTotal > availableAccount) {
                return orderTotal - availableAccount;
            } else {
                return orderTotal;
            }
        }
    },
    watch: {
        '$parent.order_data.is_pay_way_terms': {
            handler() {
                this.$nextTick(() => {
                    this.checkAndSetRemainingCardPayment();
                });
            },
            immediate: true
        },
        '$parent.order_data.remaining_pay_card_details': {
            handler() {
                this.$nextTick(() => {
                    this.checkAndSetRemainingCardPayment();
                });
            },
            deep: true,
            immediate: true
        },
        '$parent.order_data.is_remaining_pay_card': {
            handler() {
                this.$nextTick(() => {
                    this.checkAndSetRemainingCardPayment();
                });
            },
            immediate: true
        },
        'termPaymentInfo.avalaible_on_account': {
            handler() {
                this.$nextTick(() => {
                    this.checkAndSetRemainingCardPayment();
                });
            },
            immediate: true
        },
        'order_data.order_price': {
            handler() {
                this.$nextTick(() => {
                    this.checkAndSetRemainingCardPayment();
                });
            },
            immediate: true
        },
        'order_data.grand_total_price': {
            handler() {
                this.$nextTick(() => {
                    this.checkAndSetRemainingCardPayment();
                });
            },
            immediate: true
        }
    },
    mounted() {
        var _this = this;
        _this.cartNotEmpty =
            localStorage.getItem("cartNotEmpty") === "true" || false;
        
        // Wait for data to be ready, then check
        _this.$nextTick(() => {
            setTimeout(() => {
                _this.checkAndSetRemainingCardPayment();
            }, 100);
        });
    },

    methods: {
        setGiftCardNumber(event) {
            var _this = this;
            let value = event.target.value;
            _this.$parent.order_data.giftcardnumber = value;
        },

        setGiftCardPin(event) {
            var _this = this;
            let value = event.target.value;
            _this.$parent.order_data.giftcardpin = value;
        },

        setSpecialComment(event) {
            var _this = this;
            let value = event.target.value;
            _this.$parent.order_data.specialcomment = value;
        },

        setCouponCode(event) {
            var _this = this;
            let value = event.target.value;
            _this.$parent.order_data.couponcode = value;
        },

        editData(type) {
            var _this = this;
            if (type == "shipping_billing") {
                _this.$parent.is_reviewpay = false;
                _this.$parent.is_payment = false;
            } else if (type == "payment_shipment") {
                _this.$parent.is_reviewpay = false;
                _this.$parent.is_payment = true;
            } else if (type == "review_pay") {
                _this.$parent.is_reviewpay = true;
                _this.$parent.is_payment = false;
            }
        },
        getCardImage(cardType) {
            if (!cardType) return "/maincss/images/visa_logo.png";
            const cardTypeLower = cardType.toLowerCase();
            if (cardTypeLower === "visa") {
                return "/maincss/images/visa_logo.png";
            } else if (
                cardTypeLower === "mastercard" ||
                cardTypeLower === "master"
            ) {
                return "/maincss/images/master_card_logo.png";
            } else if (
                cardTypeLower === "amex" ||
                cardTypeLower === "american express" ||
                cardTypeLower === "americanexpress"
            ) {
                return "/maincss/images/american_express_logo.svg";
            } else if (cardTypeLower === "discover") {
                return "/maincss/images/discover_logo.png";
            } else if (cardTypeLower === "jcb") {
                return "/maincss/images/jcb_logo.svg";
            }
            return "/maincss/images/visa_logo.png"; // default
        },
        checkAndSetRemainingCardPayment() {
            var _this = this;
            
            // Check if pay via terms is selected and available account is less than order total
            if (
                _this.$parent &&
                _this.$parent.order_data &&
                _this.$parent.order_data.is_pay_way_terms &&
                _this.termPaymentInfo
            ) {
                const availableAccount = parseFloat(_this.termPaymentInfo.avalaible_on_account || 0);
                const orderTotal = parseFloat(
                    _this.$parent.order_data.grand_total ||
                    _this.$parent.order_data.order_price || 
                    _this.$parent.order_data.grand_total_price || 
                    _this.order_data.order_price || 
                    _this.order_data.grand_total_price || 
                    (_this.$parent.$refs.cartSummaryRef ? _this.$parent.$refs.cartSummaryRef.calculatedGrandTotal : 0) ||
                    0
                );
                
                // If available account is less than order total OR negative (overdraft), there's a remaining card payment
                const shouldShowRemainingPayment = (availableAccount < orderTotal && orderTotal > 0) || (availableAccount < 0);
                
                if (shouldShowRemainingPayment) {
                    // Check if remaining card details exist
                    const remainingCardDetails = _this.$parent.order_data.remaining_pay_card_details;
                    const hasCardDetails = remainingCardDetails && 
                        (remainingCardDetails.cardnumber || 
                         remainingCardDetails.customerPaymentProfileId);
                    
                    // Show if card details exist OR available account is negative OR is_remaining_pay_card flag is true
                    if (hasCardDetails || availableAccount < 0 || _this.$parent.order_data.is_remaining_pay_card) {
                        _this.showRemainingCardPayment = true;
                        if (remainingCardDetails) {
                            _this.$parent.order_data.is_remaining_pay_card = true;
                        }
                        _this.$parent.order_data.is_pay_way_terms = true;
                    } else {
                        _this.showRemainingCardPayment = false;
                    }
                } else {
                    _this.showRemainingCardPayment = false;
                }
            } else {
                _this.showRemainingCardPayment = false;
            }
            
            // Force update to ensure reactivity
            _this.$forceUpdate();
        }
    }
};
</script>

<style scoped>
.user_name_address {
    margin-top: -5px;
    font-weight: 500;
    font-size: 15px;
}
.review_and_pay_page .company_card_rp .company_card_name {
    margin-bottom: 12px !important;
}
.review_and_pay_page .company_card_rp .company_card_address {
    margin-bottom: 5px !important;
}
.review_and_pay_page .company_card_rp .company_card_address {
    align-items: center !important;
}
</style>